export default function formatPrice(price) {
  const formattedPrice = parseFloat(price, 10)
  if(Number.isNaN(formattedPrice)) {
    return ''
  }
  return Math.ceil(formattedPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
